import styled, { css } from 'styled-components';

import { theme } from '@/theme';

export const FooterContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 32px;
  background-color: ${(props) => props.theme.colors.white};

  ${theme.media.sm.up} {
    padding: 40px;
    padding-bottom: 64px;
    height: auto;
  }
`;

export const BannerImage = styled.div<{ $backgroundImage: string }>`
  position: relative;
  width: 100%;
  height: 200px;
  background-image: url(${({ $backgroundImage }) => $backgroundImage});
  background-size: cover;
  background-position: center;
  filter: brightness(0.7);

  ${theme.media.sm.up} {
    height: 408px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  max-width: 880px;
  padding-inline: 15px;

  ${theme.media.sm.up} {
    padding: 0;
  }
`;

export const Title = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.colors.default};
    font-weight: ${theme.fontWeights.semibold};
    font-size: ${theme.fontSizes.h2Mobile};
    font-family: ${theme.fonts.titleFont};

    ${theme.media.sm.up} {
      font-size: ${theme.fontSizes.h2};
    }
  `}
`;

export const Description = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => css`
    color: ${theme.colors.default};
    line-height: ${theme.lineHeights.p1};
    font-weight: ${theme.fontWeights.regular};
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fonts.paragraphFont};
  `}
`;
